var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-select",
      class: [_vm.sizeCss, { "is-disabled": _vm.isDisabled }],
      style: { width: _vm.selectWidth },
      on: {
        mouseover: _vm.handlerMouseover,
        mouseout: function ($event) {
          _vm.isMouseover = false
        },
      },
    },
    [
      _vm.isShowInput
        ? _c("v-input", {
            ref: "input",
            staticClass: "v-select__input",
            class: {
              "v-select__input--clear": _vm.inputValue && _vm.isClear,
              "is-focus": _vm.dropdownShow,
            },
            attrs: {
              "is-child": "",
              name: _vm.name,
              id: _vm._f("id")(_vm.name, "input"),
              "data-name": _vm._name,
              maxlength: _vm.maxlength,
              minlength: _vm.minlength,
              disabled: _vm.isDisabled,
              "is-clear": _vm.isClear,
              unit: _vm.unit,
              allow: _vm.allow,
              size: _vm.size,
              ignoreUpdateValue: true,
            },
            on: {
              blur: _vm.handlerBlur,
              input: _vm.handlerInput,
              focus: _vm.handlerFoucs,
              change: _vm.changeValue,
            },
            model: {
              value: _vm.inputValue,
              callback: function ($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue",
            },
          })
        : _c(
            "div",
            {
              staticClass: "v-select__label input-text",
              class: {
                "is-disabled": _vm.isDisabled,
                "is-focus": _vm.dropdownShow,
              },
              style: _vm.multipleShowAll && { height: "auto" },
              attrs: {
                name: _vm.name,
                id: _vm._f("id")(_vm.name, "body"),
                "data-name": _vm._name,
              },
              on: { click: _vm.showOptions },
            },
            [
              !_vm.isMultiple
                ? _c(
                    "div",
                    {
                      staticClass: "v-select__label--text",
                      attrs: { id: _vm._f("id")(_vm.name, "text") },
                    },
                    [_vm._v(" " + _vm._s(_vm.selectLabel) + " ")]
                  )
                : _vm.multipleLabel.length > 0
                ? _c(
                    "div",
                    {
                      ref: "multipleText",
                      staticClass:
                        "v-select__label--text v-select__label--position",
                      style: _vm.multipleShowAll && { whiteSpace: "normal" },
                    },
                    [
                      _vm.multipleShowAll
                        ? _vm._l(_vm.multipleLabel, function (item) {
                            return _c(
                              "span",
                              {
                                key: item.label,
                                staticClass: "v-select__label__item multi__all",
                                class: { disabled: item.disabled },
                              },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      "max-width": 200,
                                      enterable: false,
                                      "between-space": 0,
                                      "word-break": "break-all",
                                      "show-only-ellipsis": "",
                                      content: item.label,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "v-select__label--text__item ellipsis",
                                        style: {
                                          maxWidth: _vm.multiAllWidth,
                                        },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    ),
                                  ]
                                ),
                                _c("span", {
                                  staticClass:
                                    "v-select__icon--right v-icon-close",
                                  attrs: {
                                    id: _vm._f("id")(
                                      _vm.name,
                                      `${item.label}-del`
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.delValue(item)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          })
                        : [
                            _c(
                              "span",
                              {
                                staticClass: "v-select__label__item multi__all",
                                class: {
                                  disabled: _vm.multipleLabel[0].disabled,
                                },
                              },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      "max-width": 200,
                                      enterable: false,
                                      "between-space": 0,
                                      "show-only-ellipsis": "",
                                      content: _vm.multipleLabel[0].label,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "v-select__label--text__item ellipsis",
                                        style: {
                                          maxWidth: _vm.multiNumWidth,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.multipleLabel[0].label)
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("span", {
                                  staticClass:
                                    "v-select__icon--right v-icon-close",
                                  attrs: { id: _vm._f("id")(_vm.name, "del") },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.delValue(_vm.multipleLabel[0])
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.multipleLabel.length > 1
                              ? _c(
                                  "span",
                                  { staticClass: "v-select__label__item" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "v-select__label--text__item",
                                      },
                                      [
                                        _vm._v(
                                          " +" +
                                            _vm._s(
                                              _vm.multipleLabel.length - 1
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _vm.isEmpty
                ? _c(
                    "div",
                    { ref: "EmptyText", staticClass: "placeholder-text" },
                    [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]
                  )
                : _vm._e(),
            ]
          ),
      _c("span", {
        staticClass: "v-select__icon",
        class: {
          "v-select__icon--active": _vm.dropdownShow,
          "v-icon-down": !_vm.hasClear,
          "v-icon-close-plane": _vm.hasClear,
        },
        attrs: { id: _vm._f("id")(_vm.name, "icon") },
        on: {
          click: function ($event) {
            return _vm.showOptions(true)
          },
        },
      }),
      _c(
        "create-to-body",
        {
          directives: [
            {
              name: "clickoutside",
              rawName: "v-clickoutside",
              value: _vm.hide,
              expression: "hide",
            },
          ],
          ref: "body",
          attrs: {
            "data-name": _vm._name,
            show: _vm.dropdownShow,
            position: _vm.position,
            "insert-contains": _vm.insertContains,
          },
        },
        [
          _vm.isSearch
            ? _c("search-input", {
                staticClass: "v-select__search",
                attrs: {
                  placeholder: _vm.searchPlaceholder,
                  "is-search": "",
                  "no-id": "",
                  name: _vm._f("id")(_vm.name, "search"),
                },
                on: {
                  search: _vm.search,
                  input: (val) => (_vm.searchText = val),
                },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              })
            : _vm._e(),
          _c("dropdown-list", {
            class: _vm.sizeCss,
            attrs: {
              "option-max-width": _vm.optionMaxWidth,
              options: _vm.searchText ? _vm.searchList : _vm.optionList,
              "is-multiple": _vm.isMultiple,
              "high-light-text": _vm.searchText,
              "multiple-limit": _vm.multipleLimit,
              "select-value": _vm.value,
              count: _vm.displayOptionsNumber,
              fn: _vm.$scopedSlots.default,
              "is-exsit": !!_vm.isExsitOption,
              "no-id": _vm.noId,
              name: _vm._f("id")(_vm.name, "list"),
            },
            on: { "click-options": _vm.clickOptions, hide: _vm.hide },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }